/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { ColorProps } from '../UNSAFE_interpolations/colors';
import { VisThresholdsColors } from './meterTypes';
import { colorSchemeVars } from '../../Common/themes/themeContract.css';

/**
 * Returns the color of the threshold.
 * @param color The color provided via prop of the visualization component.
 * @returns The color of the threshold.
 */
export function getVisThresholdColor(color: ColorProps['color'] | VisThresholdsColors) {
  const colorAsString: string = color as string;
  if (colorAsString === 'danger' || colorAsString === 'warning' || colorAsString === 'success') {
    return colorSchemeVars.dvt.threshold[colorAsString];
  }
  return color;
}
